import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import FooterBar from './components/FooterBar';
import HomePage from './pages/HomePage';
import ProjectsPage from './pages/ProjectsPage';
import AccountPage from './pages/AccountPage';
import ProjectPage from './pages/ProjectPage';
import NoResultsPage from './pages/NoResultsPage';
import CreateProjectPage from './pages/CreateProjectPage'; // Create this page if needed
import CreateUserPage from './pages/CreateUserPage';
import ObjectsPage from './pages/ObjectsPage'; // Import the ObjectsPage component
import ObjectPage from './pages/ObjectPage'; // Import the ObjectPage component
import LoginPage from './pages/LoginPage'; // Import LoginPage


import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import Categories from './pages/Categories';
import Category from './pages/Category';
import './App.css';

const App = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/projets" element={<ProjectsPage />} />
        <Route path="/project/:slug" element={<ProjectPage />} /> {/* Dynamic route with slug */}
        <Route path="/no-results" element={<NoResultsPage />} />
        <Route path="/objets" element={<ObjectsPage />} /> {/* New route */}
        <Route path="/objets/:id" element={<ObjectPage />} /> {/* Legacy dynamic route for backward compatibility */}
        <Route path="/objets/:idSlug" element={<ObjectPage />} /> {/* SEO-friendly dynamic route */}
        <Route path="/object/:idSlug" element={<ObjectPage />} /> {/* SEO-friendly singular route for /object/5-guitare */}
        <Route path="/mon-compte" element={<AccountPage />} />
        <Route path="/create-project" element={<CreateProjectPage />} /> {/* Optional */}
        <Route path="/create-user" element={<CreateUserPage />} />
        <Route path="/login" element={<LoginPage />} /> {/* Route for LoginPage */}
        <Route path="/categories" element={<Categories />} />
        <Route path="/category/:slug" element={<Category />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      </Routes>
      <FooterBar />
    </>
  );
};

export default App;